
<div class="modal-header mfp-header">
    <h5 class="modal-title">Departments</h5>
    <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="Cancel()"
    ></button>
</div>
<div class="modal-body">
    <div class="container-fluid">
        <div class="row my-2">
            <div class="col-12 col-md-6">Username:</div>
            <div class="col-12 col-md-6">
                <input type="text" class="form-control" [(ngModel)]="Username" [disabled]="!EmployeeID" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Password:</div>
            <div class="col-12 col-md-6">
                <input type="password" class="form-control" [(ngModel)]="Password" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Confirm Password:</div>
            <div class="col-12 col-md-6">
                <input type="password" class="form-control" [(ngModel)]="PasswordConfirm" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Requirements:</div>
            <div class="col-12 col-md-6">
                <ul>
                    <li>1 Letter (A-Z, a-z)</li>
                    <li>1 Number (0-9)</li>
                    <li>At least 8 characters long</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button"
            class="btn btn-secondary"
            (click)="Cancel()">
        Cancel
    </button>
    <button type="button"
            class="btn btn-primary"
            (click)="Save()"
            [disabled]="!this.Password || this.Password != this.PasswordConfirm">
        Save
    </button>
</div>
